import React, { useState } from 'react';

import {
    Col, Row, Button, Collapse,
} from 'react-bootstrap';

import { InputField, TextAreaField } from './edit_blocks';

const gridStyles = { marginTop: 12, marginBottom: 6 };

export default function SeoSettings({
    handleChange, withSeoText, not_valid, seo_title, seo_descr, seo_text, custom_canonical,
}) {
    const [isActive, setActive] = useState(false);

    function toggleSeo() {
        setActive(!isActive);
    }

    return (
        <>
            <Row className="show-grid" style={gridStyles}>
                <Col md={3}>
                    <Button variant="outline-primary" size="sm" onClick={toggleSeo}>SEO настройки</Button>
                </Col>
            </Row>
            <Collapse in={isActive}>
                <div>
                    <Row>
                        <Col md={8}>
                            <InputField
                                name="seo_title"
                                label="SEO заголовок"
                                value={seo_title}
                                onChange={handleChange}
                                maxLength={100}
                                required
                                is_not_valid={(not_valid && not_valid.seo_title) || false}
                            />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={8}>
                            <TextAreaField
                                name="seo_descr"
                                label="SEO описание"
                                value={seo_descr}
                                onChange={handleChange}
                                maxLength={200}
                                rows={4}
                            />
                        </Col>
                    </Row>
                    {withSeoText && (
                        <Row>
                            <Col md={8}>
                                <TextAreaField
                                    name="seo_text"
                                    label="SEO текст"
                                    value={seo_text}
                                    onChange={handleChange}
                                    rows={10}
                                />
                            </Col>
                        </Row>
                    )}
                    <Row>
                        <Col md={8}>
                            <InputField
                                name="custom_canonical"
                                label="Ручной canonical URL"
                                value={custom_canonical}
                                onChange={handleChange}
                                maxLength={255}
                            />
                        </Col>
                    </Row>
                </div>
            </Collapse>
        </>
    );
}
